import { AddEmptyTopicDialogComponent } from './addEmptyTopicDialog.component';
import { BasicFilterEditorComponent } from './basicFilterEditor.component';
import { TopicBuilderComponent } from './topicBuilder.component';
import { CommonModule } from '@angular/common';
import { EditTopicPeopleComponent } from './editTopicPeople.component';
import { TopicsComponent } from './topics.component';
import { StartCreateTopicComponent } from './startCreateTopic.component';
import { EditTopicContentSourcesTabComponent } from './editTopicContentSourcesTab.component';
import { NgModule } from "@angular/core";
import { InviteToTopicComponent } from "./inviteToTopic.component";
import { EditTopicContentFiltersTabComponent } from "./editTopicContentFiltersTab.component";
import { EditTopicContentComponent } from './editTopicContent.component';
import { EditTopicContentItemsTabComponent } from './editTopicContentItemsTab.component';
import { EditTopicComponent } from './editTopic.component';
import { EditTopicContentAddSourcesComponent } from './editTopicContentAddSources.component';
import { EditTopicSettingsComponent } from './editTopicSettings.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MaterialModule } from '../../material.module';
import { MomentModule } from 'ngx-moment';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { GeneralModule } from '../general/general.module';
import { RouterModule } from '@angular/router';
import { TagPickerComponent } from './tagPicker.component';
import { FilterBuilderComponent } from './filterBuilder.component';
import { TopicBuilderPreviewComponent } from './topicBuilderPreview.component';
import { TopicBuilderShareComponent } from './topicBuilderShare.component';
import { TopicBuilderPublishComponent } from './topicBuilderPublish.component';
import { TopicCategoryManagerComponent } from './topicCategoryManager.component';
import { TopicTagManagerComponent } from './topicTagManager.component';
import { TopicBuilderSourcesComponent } from './topicBuilderSources.component';
import { StartersCreateTopicComponent } from './startersCreateTopic.component';
import { EditTopicGroupsComponent } from './editTopicGroups.component';
import { SelectMultipleGroupsDialogComponent } from './selectMultipleGroupsDialog.component';
import { EditTopicContentItemsTabContainerComponent } from './editTopicContentItemsTabContainer.component';
import { AttensaEditorModule } from '../attensaEditor/attensaEditor.module';
import { PipesModule } from '../pipes/pipes.module';
import { MaterialFileInputModule } from 'ngx-material-file-input';
import { EditTopicContentSourcePreviewComponent } from './editTopicContentSourcePreview.component';
import { SummaryModule } from '../summary/summary.module';
import { ReadingModule } from '../reading/reading.module';
import { NavigationModule } from '../navigation/navigation.module';
import { CatalogTopicCategoryManagerComponent } from './catalogTopicCategoryManager.component';

@NgModule({
    imports: [
        AttensaEditorModule,
        CommonModule,
        FlexLayoutModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        MaterialFileInputModule,
        MaterialModule,
        MomentModule,
        NavigationModule,
        PipesModule,
        ReadingModule,
        RouterModule,
        SummaryModule,
        InfiniteScrollModule,
        GeneralModule,
    ],
    declarations: [
        AddEmptyTopicDialogComponent,
        BasicFilterEditorComponent,
        CatalogTopicCategoryManagerComponent,
        InviteToTopicComponent,
        EditTopicContentFiltersTabComponent,
        EditTopicContentSourcesTabComponent,
        EditTopicContentSourcePreviewComponent,
        FilterBuilderComponent,
        StartersCreateTopicComponent,
        StartCreateTopicComponent,
        TopicBuilderComponent,
        TopicBuilderPreviewComponent,
        TopicBuilderShareComponent,
        TopicBuilderPublishComponent,
        TopicBuilderSourcesComponent,
        TopicCategoryManagerComponent,
        TopicTagManagerComponent,
        TagPickerComponent,
        TopicsComponent,
        EditTopicContentComponent,
        EditTopicContentItemsTabComponent,
        EditTopicContentItemsTabContainerComponent,
        EditTopicComponent,
        EditTopicContentAddSourcesComponent,
        EditTopicSettingsComponent,
        EditTopicPeopleComponent,
        EditTopicGroupsComponent,
        SelectMultipleGroupsDialogComponent
    ],
    exports: [
        AddEmptyTopicDialogComponent,
        InviteToTopicComponent,
        EditTopicContentFiltersTabComponent,
        EditTopicContentSourcesTabComponent,
        StartCreateTopicComponent,
        TopicBuilderComponent,
        TagPickerComponent,
        TopicsComponent,
        EditTopicContentComponent,
        EditTopicContentItemsTabComponent,
        EditTopicContentItemsTabContainerComponent,
        EditTopicComponent,
        EditTopicContentAddSourcesComponent,
        EditTopicSettingsComponent,
        EditTopicPeopleComponent,
        EditTopicGroupsComponent
    ],
    entryComponents: [
        AddEmptyTopicDialogComponent,
        SelectMultipleGroupsDialogComponent
    ]
})
export class TopicsModule {
}